/* eslint-disable jsx-a11y/alt-text */
import React, { createRef } from 'react';
import { imageWithPrefix } from '../../scripts/helpers';
import { placeholder } from '../../scripts/media';

export type ImageProps = {
  lazyLoading?: boolean;
  alt?: string;
  src: string;
  className?: string;
  id?: string;
  width?: string;
  height?: string;
  placeholder?: string;
};

export default class Image extends React.Component<ImageProps> {
  private placeholderRef: any;

  options = this.updateOptions();

  constructor(props: ImageProps) {
    super(props);
    if (props.lazyLoading) {
      this.placeholderRef = createRef();
    }
  }

  componentDidMount() {
    if (this.props.lazyLoading) {
      this.observe();
    }
  }

  componentDidUpdate(prevProps: ImageProps): void {
    if (prevProps.src !== this.props.src) {
      this.options = this.updateOptions();
      if (this.props.lazyLoading) {
        this.observe();
      }
    }
  }

  updateOptions() {
    const options: any = { ...this.props };
    if (options.placeholder) {
      delete options.placeholder;
    }
    options.alt = options.alt || '';
    if (this.props.lazyLoading) {
      options.src = this.props.placeholder || placeholder;
      options['data-src'] = this.props.src;
    } else {
      options.src = imageWithPrefix(this.props.src);
    }
    if (Object.prototype.hasOwnProperty.call(options, 'lazyLoading')) {
      delete options.lazyLoading;
    }
    return options;
  }

  observe() {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.setAttribute('src', imageWithPrefix(this.props.src));
            obs.disconnect();
          }
        });
      },
      {
        rootMargin: '250px',
        threshold: 0
      }
    );
    observer.observe(this.placeholderRef.current);
    return () => {
      observer.disconnect();
    };
  }

  render() {
    return this.props.lazyLoading ? (
      <img
        {...this.options}
        ref={this.placeholderRef}
        loading="lazy"
      />
    ) : (
      <img {...this.options} />
    );
  }
}
